import React from "react";
import ModuleShowcasePage from "../../marketing/ModuleShowcasePage";

const AsapCV = () => <ModuleShowcasePage moduleKey="cv" />;

export default AsapCV;
